"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation resendTicketShareOffer($sharingId: String!, $orderId: String!) {
    resendTicketShareOffer(sharingId: $sharingId, orderId: $orderId) {
      _id
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=resendTicketShareOffer.mutation.js.map